<template>
  <div class="container">
    <van-sticky>
      <PublicHeader :totalName="$t('position').title" />
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span></div>
        <!-- 产品业务 -->
        <div class="businesstabs">
          <span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`" :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab(item.value)">{{ item.name
            }}</span>
        </div>
      </div>
    </van-sticky>
    <!-- 订单列表 -->
    <div class="orderList">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getOrderList" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`">
          <div class="topname">
            <div class="name">
              <span>{{ dItem.name }}</span>
              <div class="p1" v-if="dItem.productBusiness == 3" :class="dItem.buyDirection == '0' ? 'greenbg' : 'redbg'">
                {{  dItem.buyDirection == '0' ?  $t('trade').buyBtn : $t('trade').sellBtn }}</div>
              <div class="p1" v-if="dItem.productBusiness == 1||dItem.productBusiness == 2" :class="dItem.buyDirection == '0' ? 'greenbg' : 'redbg'">
                {{ dItem.buyDirection == '0'  ?  $t('trade').Kato : $t('trade').Openempty }}</div>
              <div class="p1" v-if="!dItem.productBusiness" :class="dItem.buyDirection == '0' ? 'greenbg' : 'redbg'">
                {{ dItem.buyDirection == '0'  ?  $t('trade').buyUp : $t('trade').buyDown }}</div>
              <div class="p2" v-if="dItem.productBusiness == 1||dItem.productBusiness == 2">{{ dItem.lever }}X</div>
              <span :class="dItem.priceChangeRatio > 0 ? 'green' : 'red'">{{ dItem.priceChangeRatio }}%</span>
            </div>
            <van-icon name="arrow" color="var(--text_color)" size="16" @click="toOrderInfo(dItem)" />
          </div>
          <div class="itInfo">
            <!-- 当前价格 -->
            <div class="itt">
              <div class="lable">{{ $t('position').Currentprice }} </div>
              <div class="txt" :class="dItem.priceChangeRatio > 0 ? 'green' : 'red'">{{ dItem.newPrice }}</div>
            </div>
            <!--  止盈价-->
            <div class="itt" v-if="dItem.stopSurplusPrice">
              <div class="lable">{{ $t('position').stopSurplusPrice }} </div>
              <div class="txt">{{ dItem.stopSurplusPrice }}</div>
            </div>
            <!-- 止损价 -->
            <div class="itt" v-if="dItem.stopLossPrice">
              <div class="lable">{{ $t('position').Stoplossprice }} </div>
              <div class="txt">{{ dItem.stopLossPrice }}</div>
            </div>
            <!-- 委托价 -->
            <div class="itt">
              <div class="lable">{{ $t('position').Entrustedprice }} </div>
              <div class="txt">{{ dItem.price }}</div>
            </div>
            <!-- 委托数量 -->
            <div class="itt" v-if="dItem.productBusiness">
              <div class="lable">{{ $t('position').Entrustednum }} </div>
              <div class="txt">{{ dItem.quantity }}</div>
            </div>
            <!-- 保证金 -->
            <div class="itt" v-if="dItem.productBusiness == 1||dItem.productBusiness == 2">
              <div class="lable">{{ $t('position').margin }} </div>
              <div class="txt">{{ dItem.margin }}</div>
            </div>
            <!-- 手续费 -->
            <div class="itt" v-if="dItem.productBusiness != 3">
              <div class="lable">{{ $t('position').changeRate }} </div>
              <div class="txt">{{ dItem.changeRate ||'-'}}</div>
            </div>
            <!-- 市值 -->
            <div class="itt" v-if="active != '3' && (dItem.productBusiness == 1||dItem.productBusiness == 2)">
              <div class="lable">{{ $t('position').marketvalue }} </div>
              <div class="txt">{{ (dItem.newPrice * dItem.quantity).toFixed(6).replace(/\.?0+$/, '') }}</div>
            </div>
            <!-- 订单金额 -->
            <div class="itt" v-if="dItem.productBusiness == 3||!dItem.productBusiness">
              <div class="lable">{{ $t('position').orderAmount }} </div>
              <div class="txt">{{ dItem.amount }}</div>
            </div>
            <!-- 订单号 -->
            <div class="itt">
              <div class="lable">{{ $t('position').orderno }} </div>
              <div class="txt2">{{ dItem.orderNo }}<svg-icon class-name="svgs" icon-class="copy" @click="onCopy(dItem.orderNo)" /></div>
            </div>
            <!-- 委托时间 -->
            <div class="itt">
              <div class="lable">{{ $t('position').Entrustedtime }} </div>
              <div class="txt2">{{ dItem.createTime | getLocalTime }}</div>
            </div>
            <!-- 盈亏 -->
            <div class="itt" v-if="active != '3' &&  (dItem.productBusiness == 1||dItem.productBusiness == 2) && dItem.profitAmount_new">
              <div class="lable">{{ $t('position').profitloss }} </div>
              <div class="txt" :class="dItem.profitAmount_new > 0 ? 'green' : 'red'">{{ dItem.profitAmount_new }}</div>
            </div>
            <!-- 盈亏百分比 -->
            <div class="itt" v-if="active != '3' &&  (dItem.productBusiness == 1||dItem.productBusiness == 2) && dItem.profitRate_new">
              <div class="lable">{{ $t('position').profitloss }}% </div>
              <div class="txt" :class="dItem.profitRate_new > 0 ? 'green' : 'red'">{{ dItem.profitRate_new }}%</div>
            </div>
            <!-- 盈亏 -->
            <div class="itt" v-if="active == '3' &&  (dItem.productBusiness == 1||dItem.productBusiness == 2)">
              <div class="lable">{{ $t('position').profitloss }} </div>
              <div class="txt" :class="dItem.profitAmount > 0 ? 'green' : 'red'">{{ dItem.profitAmount }}</div>
            </div>
            <!-- 盈亏百分比 -->
            <div class="itt" v-if="active == '3' &&  (dItem.productBusiness == 1||dItem.productBusiness == 2)">
              <div class="lable">{{ $t('position').profitloss }}% </div>
              <div class="txt" :class="dItem.profitAmount > 0 ? 'green' : 'red'">{{ (dItem.profitAmount/dItem.margin* 100).toFixed(2).replace(/\.?0+$/, '') }}%</div>
            </div>
            <!-- 盈亏 -->
            <div class="itt" v-if="!dItem.productBusiness">
              <div class="lable">{{ $t('position').profitloss }} </div>
              <div class="txt" :class="dItem.profitAmount > 0 ? 'green' : 'red'">{{ dItem.profitAmount||'-' }}</div>
            </div>
            <!-- 结算价格 -->
            <div class="itt" v-if="active == '3' &&  (dItem.productBusiness == 1||dItem.productBusiness == 2)">
              <div class="lable">{{ $t('position').SettlementPrice }} </div>
              <div class="txt">{{ dItem.salesPrice }}</div>
            </div>
            <!-- 结算时间 -->
            <div class="itt" v-if="active == '3' &&dItem.productBusiness != 3">
              <div class="lable">{{ $t('position').Settlementtime }} </div>
              <div class="txt2">{{ dItem.salesTime | getLocalTime }}</div>
            </div>
          </div>
          <div class="btnInfo" v-if="active != '3'&& dItem.productBusiness">
            <!-- 取消 -->
            <div class="b1 redbg" v-if="active == '1'" @click="toCancelOrder(dItem)">{{ $t('public').cancel }}</div>
            <!-- 设置止盈止损 -->
            <div class="b2" v-if="active == '2'" @click="toSetInfo(dItem)">{{ $t('position').Settakeprofitloss }}</div>
            <!-- 平仓 -->
            <div class="b1 redbg" v-if="active == '2'" @click="toSettleOrder(dItem)">{{ $t('position').closeposition }}
            </div>
          </div>
        </div>
      </van-list>
      <div class="empty" v-if="isEmpty">
        <svg-icon class-name="esvgs" icon-class="empty" />
        <div class="txt">{{ $t('public').emptyTxt }}</div>
      </div>
    </div>
    <!-- 设置止盈止损 -->
    <van-popup v-model="showSetInfo" closeable :style="{ width: '350px' }">
      <div class="setInfo">
        <div class="name">{{ orderInfo.name }}
          <span v-if="orderInfo.productBusiness == 3" :class="orderInfo.buyDirection == '0' ? 'green' : 'red'">{{
            orderInfo.buyDirection == '0' ? $t('trade').buyBtn : $t('trade').sellBtn }}</span>
          <span v-else :class="orderInfo.buyDirection == '0' ? 'green' : 'red'">{{
            orderInfo.buyDirection == '0' ? $t('trade').Kato : $t('trade').Openempty }}</span>
          <span :class="orderInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ orderInfo.priceChangeRatio }}%</span>
        </div>
        <!-- 止盈价 -->
        <div class="item" v-if="orderInfo.stopSurplusPrice">{{ $t('position').stopSurplusPrice }} <span>{{
          orderInfo.stopSurplusPrice }}</span></div>
        <!-- 当前价 -->
        <div class="item">{{ $t('position').Currentprice }} <span :class="orderInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ orderInfo.newPrice
            }}</span></div>
        <!-- 止损价 -->
        <div class="item" v-if="orderInfo.stopLossPrice">{{ $t('position').Stoplossprice }} <span>${{
          orderInfo.stopLossPrice }}</span></div>
        <div class="item">
          <van-field v-model="StopSurplusPrice" type="number" :label="$t('trade').zyPrice" />
          <van-field style="margin-left: 15px;" v-model="StopLossPrice" type="number" :label="$t('trade').zsPrice" />
        </div>
        <div class="btns">
          <div class="b1" @click="showSetInfo = false">{{ $t('public').cancel }}</div>
          <div class="b2" @click="stopOrderSet">{{ $t('public').confirm }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import orderApi from '@/api/order'
import { webSocket } from "@/mixins/webSocket.js";

export default {
  mixins: [webSocket],
  components: {
    PublicHeader
  },
  data() {
    return {
      isEmpty: false,
      showSetInfo: false,
      StopSurplusPrice: '',
      StopLossPrice: '',
      active: "1",
      tabs: [{
        "name": this.$t('position').Position,
        "value": "1"
      }, {
        "name": this.$t('position').commission,
        "value": "2"
      }, {
        "name": this.$t('position').Settlement,
        "value": "3"
      },
      ],
      //产品业务
      activeBusiness: 1,
      tabsBusiness: [{
        name: this.$t('public').USDTcontract,
        value: 1
      },
      // {
      //   name: this.$t('public').Fiatcurrencycontract,
      //   value: 2
      // },
      {
        name: this.$t('public').spot,
        value: 3
      }, {
        name: this.$t('public').secondContract,
        value: 4
      }],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
      orderInfo: {},
      timer: null,
    }
  },
  mounted() {
    this.refreshOrderList()
    this.timer = setInterval(() => {
      this.getNowPageOrderList();
    }, 3000);
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
    clearInterval(this.timer);
  },
  methods: {
    toOrderInfo(dItem) {
      if (dItem.productBusiness)
        this.$router.push({ name: 'PositionInfo', query: { i: dItem.orderId } })
      else this.$router.push({ name: 'PositionSecondInfo', query: { i: dItem.orderSecondId } })
    },
    //切换
    changeTab(val) {
      this.active = val
      this.refreshOrderList()
    },
    //切换产品业务
    changeBusinessTab(val) {
      this.activeBusiness = val
      this.refreshOrderList()
    },
    //刷新获取订单列表
    refreshOrderList() {
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      if (this.activeBusiness == 4) this.getSecondOrderList()
      else this.getOrderList()
    },
    // 轮训刷新当前页订单列表
    async getNowPageOrderList() {
      if (this.isRun) return
      const currentPage = this.parms.pageNum > 1 ? this.parms.pageNum - 1 : 1;
      const startIndex = (currentPage - 1) * this.parms.pageSize;
      const parms = {
        ...this.parms,
        productBusiness: this.activeBusiness,
        status: this.active,
        pageNum: currentPage
      }
      var res = null
      if (this.activeBusiness == 4) {
        res = await orderApi.getSecondOrderList(parms)
      }
      else res = await orderApi.getOrderList(parms)
      const newRows = res.rows;
      // 用 Map 快速查找当前页已有订单对应索引
      const idMap = new Map();
      for (let i = startIndex; i < Math.min(this.oList.length, startIndex + this.parms.pageSize); i++) {
        const item = this.oList[i];
        if (item && item.orderId) idMap.set(item.orderId, i);
      }
      // 遍历新数据，根据 id 更新已有对象
      newRows.forEach(item => {
        if (idMap.has(item.orderId)) {
          // 更新已有对象字段
          Object.assign(this.oList[idMap.get(item.orderId)], item);
        } else {
          // 新增订单直接替换对应位置（保证页大小不变）
          const insertIndex = startIndex + newRows.indexOf(item);
          this.oList[insertIndex] = item;
        }
      });
      // 删除当前页里已经不存在的订单
      const newIds = new Set(newRows.map(i => i.orderId));
      for (let i = Math.min(this.oList.length - 1, startIndex + this.parms.pageSize - 1); i >= startIndex; i--) {
        if (!newIds.has(this.oList[i]?.orderId)) {
          this.oList.splice(i, 1);
        }
      }
    },
    // 获取订单列表
    async getOrderList() {
      if (this.isRun) return
      this.isEmpty = false
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.status = this.active
      const res = await orderApi.getOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 获取秒合约订单列表
    async getSecondOrderList() {
      if (this.isRun) return
      this.isEmpty = false
      this.isRun = true
      this.parms.status = this.active
      const res = await orderApi.getSecondOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //推送列表
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.oList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 订单列表
        that.oList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            that.$set(sItem, 'newPrice', quotes.NewPrice)
            that.$set(sItem, 'priceChangeRatio', quotes.PriceChangeRatio)
            // 非历史成交订单
            if (that.active != '3') {
              // 盈亏=持仓订单(产品价格-购买单价)【绝对值】x数量
              var profit = (Math.abs(sItem.price - quotes.NewPrice) * sItem.quantity)
              //买涨 价格下跌
              if (sItem.buyDirection == '0' && sItem.price > quotes.NewPrice)
                profit = -profit
              //买跌 价格上涨
              if (sItem.buyDirection == '1' && sItem.price < quotes.NewPrice)
                profit = -profit
              //盈亏要减去手续费
              that.$set(sItem, 'profitAmount_new', (profit - sItem.changeRate).toFixed(4).replace(/\.?0+$/, ''))
              that.$set(sItem, 'profitRate_new', (sItem.profitAmount_new / sItem.margin * 100).toFixed(2).replace(/\.?0+$/, ''))
            }
          }
        })
        // 订单详情
        let quoteInfos = reslult.find(item => item.Symbol == that.orderInfo.symbol);
        if (quoteInfos) {
          that.$set(that.orderInfo, 'newPrice', quoteInfos.NewPrice)
          that.$set(that.orderInfo, 'priceChangeRatio', quoteInfos.PriceChangeRatio)
          // 非历史成交订单
          if (that.orderInfo.status != '3') {
            // 盈亏=持仓订单(产品价格-购买单价)【绝对值】x数量
            var profit = (Math.abs(that.orderInfo.price - quoteInfos.NewPrice) * that.orderInfo.quantity)
            //买涨 价格下跌
            if (that.orderInfo.buyDirection == '0' && that.orderInfo.price > quoteInfos.NewPrice)
              profit = -profit
            //买跌 价格上涨
            if (that.orderInfo.buyDirection == '1' && that.orderInfo.price < quoteInfos.NewPrice)
              profit = -profit
            //盈亏要减去手续费
            that.$set(that.orderInfo, 'profitAmount_new', (profit - that.orderInfo.changeRate).toFixed(4).replace(/\.?0+$/, ''))
            that.$set(that.orderInfo, 'profitRate_new', (that.orderInfo.profitAmount_new / that.orderInfo.margin * 100).toFixed(2).replace(/\.?0+$/, ''))
          }
        }
      })
    },
    // 展示止盈止损
    toSetInfo(val) {
      this.orderInfo = JSON.parse(JSON.stringify(val));
      this.showSetInfo = true
      this.StopSurplusPrice = null
      this.StopLossPrice = null
    },
    //设置止盈止损
    async stopOrderSet() {
      const form = {
        orderId: this.orderInfo.orderId,
        stopSurplusPrice: this.StopSurplusPrice,
        stopLossPrice: this.StopLossPrice,
      }
      await orderApi.stopOrderSet(form)
      this.$toast(this.$t('position').Settingsuccessful)
      this.showSetInfo = false
      this.refreshOrderList()
    },
    // 平仓确认弹窗
    async toSettleOrder(val) {
      this.orderInfo = JSON.parse(JSON.stringify(val));
      if (!this.orderInfo.newPrice) return
      this.$dialog.confirm({
        title: this.$t('position').Confirmclosingorder,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.settleOrder()
        })
    },
    // 平仓
    async settleOrder() {
      await orderApi.settleOrder({ orderId: this.orderInfo.orderId, marketPrice: this.orderInfo.newPrice })
      this.$toast(this.$t('position').Closingsuccessfully)
      this.refreshOrderList()
    },
    // 取消订单确认弹窗
    async toCancelOrder(val) {
      this.orderInfo = JSON.parse(JSON.stringify(val));
      this.$dialog.confirm({
        title: this.$t('position').cancelorder,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.cancelOrder()
        })
    },
    // 取消订单
    async cancelOrder() {
      await orderApi.cancelOrder({ orderId: this.orderInfo.orderId })
      this.$toast(this.$t('position').Cancelsuccessfully)
      this.refreshOrderList()
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .top {
    padding-top: 50px;
    width: 100%;
    background: var(--background_color);

    .tabs {
      padding: 0 15px;
      font-size: 14px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;

      span {
        padding: 12px 0;
        margin-right: 20px;
      }

      .active {
        color: var(--text_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--text_color);
      }
    }

    .businesstabs {
      display: flex;
      align-items: center;
      color: var(--ntext_color);
      font-size: 13px;
      padding: 8px 15px;
      border-bottom: 1px solid var(--info_color);

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 10px;
        margin-right: 10px;
      }

      .active {
        background: var(--info_color);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 10px;
        color: var(--text_color);
      }
    }
  }

  .orderList {
    margin-bottom: 30px;

    .item {
      padding: 20px 15px;
      color: var(--text_color);
      border-bottom: 1px solid var(--info_color);

      .topname {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          display: flex;
          align-items: center;

          span {
            font-size: 14px;
            color: var(--text_color);
            font-weight: normal;
            margin-right: 5px;
          }

          .p1 {
            padding: 3px 5px;
            border-radius: 5px;
            font-size: 11px;
            color: #fff;
            margin-right: 5px;
          }

          .p2 {
            padding: 3px 5px;
            background: rgba(255, 30, 0, 0.1);
            border-radius: 5px;
            font-size: 11px;
            color: #f5465d;
            margin-right: 5px;
          }
        }
      }

      .itInfo {
        display: flex;
        flex-wrap: wrap;

        .itt {
          margin-top: 15px;
          width: 33%;

          .lable {
            font-size: 12px;
            color: var(--ntext_color);
          }

          .txt {
            margin-top: 10px;
            font-size: 15px;
            color: var(--text_color);
            overflow-wrap: break-word;
          }

          .txt2 {
            margin-top: 10px;
            font-size: 13px;
            color: var(--text_color);
            overflow-wrap: break-word;
            margin-right: 10px;

            .svgs {
              margin-left: 5px;
              width: 13px;
              height: 13px;
              color: var(--ntext_color);
            }
          }
        }
      }

      .btnInfo {
        margin-top: 15px;
        display: flex;
        justify-content: right;

        .b1 {
          padding: 7px 25px;
          border-radius: 5px;
          font-size: 12px;
          color: #fff;
        }

        .b2 {
          margin-right: 10px;
          padding: 7px 25px;
          border-radius: 5px;
          font-size: 12px;
          color: var(--text_color);
          background: var(--info_color);
        }
      }
    }

    .empty {
      margin-top: 50px;
      text-align: center;

      .esvgs {
        width: 50px;
        height: 50px;
      }

      .txt {
        margin-top: 30px;
        font-size: 12px;
        color: var(--text_color);
      }
    }
  }

  .orderInfoss {
    padding: 30px 15px 20px 15px;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      color: var(--background_color);
      background: var(--text_color);
    }

    .btns {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .b1 {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--text_color);
        background: var(--info_color);
      }

      .b2 {
        margin-left: 15px;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--background_color);
        background: var(--text_color);
      }
    }
  }

  .setInfo {
    padding: 20px 15px;

    .name {
      font-size: 18px;
      font-weight: bold;
      color: var(--text_color);
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
        font-size: 13px;
        font-weight: normal;
      }
    }

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .btns {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .b1 {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--text_color);
        background: var(--info_color);
      }

      .b2 {
        margin-left: 15px;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--background_color);
        background: var(--text_color);
      }
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__label {
  margin-right: 5px;
  display: flex;
  align-items: center;
  color: var(--ntext_color);
  width: auto;
  font-size: 12px;
  font-weight: normal;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
}

::v-deep .van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  border-radius: 10px;
  padding: 0 10px;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  height: 40px;
}
</style>
